(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("lodash"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "lodash", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["Plots"] = factory(require("react"), require("lodash"), require("react-dom"));
	else
		root["Plots"] = factory(root["React"], root["_"], root["ReactDOM"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__61__, __WEBPACK_EXTERNAL_MODULE__276__, __WEBPACK_EXTERNAL_MODULE__3__) => {
return 